export default __webpack_public_path__ + "20ccef9b2dffa17fe49763d67ca1f207.png";